import React, { useCallback, useState } from 'react';
import { ArrowLeft, Signal, Wifi, BatteryFull } from 'lucide-react';
import { Link } from 'react-router-dom';
import { BottomNav } from '../components/officer/BottomNav';
import { CameraCapture } from '../components/officer/CameraCapture';
import { OfficerHome } from '../components/officer/OfficerHome';
import { OfficerLogin, OfficerSplash } from '../components/officer/OfficerEntryScreens';
import { DocumentPreview, OcrResult, SubmissionStatus } from '../components/officer/OfficerFlowScreens';
import { MyActivities, NoticeDetails, OfficerProfile } from '../components/officer/OfficerRecordScreens';
import type { OfficerScreen } from '../types/officer';
const screenList: {
  id: OfficerScreen;
  label: string;
}[] = [{
  id: 'splash',
  label: '০১ স্প্ল্যাশ'
}, {
  id: 'login',
  label: '০২ লগইন'
}, {
  id: 'home',
  label: '০৩ হোম'
}, {
  id: 'camera',
  label: '০৪ ক্যামেরা ক্যাপচার'
}, {
  id: 'preview',
  label: '০৫ ডকুমেন্ট প্রিভিউ'
}, {
  id: 'ocr',
  label: '০৬ OCR ফলাফল'
}, {
  id: 'status',
  label: '০৭ জমার অবস্থা'
}, {
  id: 'details',
  label: '০৮ নোটিশের বিস্তারিত'
}, {
  id: 'activities',
  label: '০৯ আমার কার্যক্রম'
}, {
  id: 'profile',
  label: '১০ প্রোফাইল'
}];
const withNav: OfficerScreen[] = ['home', 'activities', 'profile'];
export function OfficerApp() {
  const [screen, setScreen] = useState<OfficerScreen>('splash');
  const [rotation, setRotation] = useState(0);
  const [enhanced, setEnhanced] = useState(false);
  const go = useCallback((s: OfficerScreen) => setScreen(s), []);
  const toLogin = useCallback(() => setScreen('login'), []);
  const render = () => {
    switch (screen) {
      case 'splash':
        return <OfficerSplash onDone={toLogin} data-id="element-2215" data-mp="31ihq71xjfovc" />;
      case 'login':
        return <OfficerLogin onLogin={() => go('home')} data-id="element-2216" data-mp="2xkk0zz3rp2ry" />;
      case 'home':
        return <OfficerHome go={go} data-id="element-2217" data-mp="1769tbj1noxwx" />;
      case 'camera':
        return <CameraCapture go={go} rotation={rotation} setRotation={setRotation} enhanced={enhanced} setEnhanced={setEnhanced} data-id="element-2218" data-mp="178vwl6hikr9c" />;
      case 'preview':
        return <DocumentPreview go={go} rotation={rotation} enhanced={enhanced} data-id="element-2219" data-mp="32ahm6raq7b71" />;
      case 'ocr':
        return <OcrResult go={go} data-id="element-2220" data-mp="378izswpduib4" />;
      case 'status':
        return <SubmissionStatus go={go} data-id="element-2221" data-mp="379aw69qt0k2g" />;
      case 'details':
        return <NoticeDetails go={go} data-id="element-2222" data-mp="3c7vxydlpfbt0" />;
      case 'activities':
        return <MyActivities go={go} data-id="element-2223" data-mp="3cai6ogkbzxct" />;
      case 'profile':
        return <OfficerProfile onLogout={() => go('login')} data-id="element-2224" data-mp="3h89twxa16vao" />;
    }
  };
  const dark = screen === 'camera' || screen === 'splash';
  return <div className="min-h-screen w-full bg-[#E9EEF5]" data-id="element-2225" data-mp="3l6r6hwc80xzh">
      <header className="border-b border-border bg-white" data-id="element-2226" data-mp="3q6vbap3ro49v">
        <div className="mx-auto flex max-w-6xl items-center gap-3 px-4 py-3" data-id="element-2227" data-mp="3uyn4l7eb4o3p">
          <Link to="/" className="flex items-center gap-1 text-sm text-[#1769AA] hover:underline" data-id="element-2228" data-mp="3v0q4qk96bxm5"><ArrowLeft className="h-4 w-4" data-id="element-2229" data-mp="3rsn5yzap70g" /> প্রোটোটাইপ হাব</Link>
          <span className="text-slate-300" data-id="element-2230" data-mp="8s838yayosm4">|</span>
          <h1 className="font-semibold text-[#003B71]" data-id="element-2231" data-mp="8pc6hdauo9z9">ডিএমপি অফিসার মোবাইল অ্যাপ্লিকেশন</h1>
        </div>
      </header>
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-8 px-4 py-8 lg:flex-row lg:items-start lg:justify-center" data-id="element-2232" data-mp="1xb2q6dbjckix">
        <div className="relative h-[820px] w-[390px] max-w-full shrink-0 overflow-hidden rounded-[48px] border-[10px] border-slate-900 bg-slate-900 shadow-2xl" data-id="element-2233" data-mp="1t8eiwa2gzlo2">
          <div className={`flex h-9 items-center justify-between px-7 text-[12px] font-semibold ${dark ? 'bg-[#003B71] text-white' : 'bg-[#003B71] text-white'} ${screen === 'camera' ? '!bg-black' : ''}`} data-id="element-2234" data-mp="1jb9v65sz7i55">
            <span data-id="element-2235" data-mp="2c07ca5lgb8wb">১০:০৪</span>
            <span className="absolute left-1/2 top-2 h-6 w-28 -translate-x-1/2 rounded-full bg-black" data-id="element-2236" data-mp="2c10auja9as3d" />
            <span className="flex items-center gap-1" data-id="element-2237" data-mp="2787820yclttx"><Signal className="h-3.5 w-3.5" data-id="element-2238" data-mp="2775wzwhc17c7" /><Wifi className="h-3.5 w-3.5" data-id="element-2239" data-mp="22anruvi3b6zc" /><BatteryFull className="h-4 w-4" data-id="element-2240" data-mp="229cqt3g14dbx" /></span>
          </div>
          <div className="relative flex h-[calc(100%-36px)] flex-col bg-white" data-id="element-2241" data-mp="2zq1pio9omzh3">
            {render()}
            {withNav.includes(screen) && <BottomNav current={screen} go={go} data-id="element-2242" data-mp="2uy1kiher9gdn" />}
          </div>
        </div>

        <aside className="w-full max-w-sm rounded-xl border border-border bg-white p-5" data-id="element-2243" data-mp="2fgjxajl0v136">
          <h2 className="font-semibold text-[#003B71]" data-id="element-2244" data-mp="2jine7nqgmxvu">স্ক্রিন নির্বাচন</h2>
          <p className="mt-1 text-xs text-slate-500" data-id="element-2245" data-mp="25im3zhob2e3p">সরাসরি যেকোনো স্ক্রিনে যান অথবা অ্যাপের ভেতরে ক্লিক করে প্রবাহ অনুসরণ করুন। ডেমো লগইন: dmp.rakib / demo@123</p>
          <nav className="mt-3 grid gap-1" data-id="element-2246" data-mp="2ahz06t12gxiy">
            {screenList.map(s => <button key={s.id} onClick={() => setScreen(s.id)} className={`rounded-md px-3 py-2 text-left text-sm ${screen === s.id ? 'bg-[#003B71] text-white' : 'hover:bg-muted'}`} data-id="element-2247" data-mp="2y8m83eazfn5i">{s.label}</button>)}
          </nav>
          <div className="mt-4 rounded-md bg-[#F4F7FB] p-3 text-xs text-slate-600" data-id="element-2248" data-mp="2ofdqdzz599bz">
            <b className="text-[#003B71]" data-id="element-2249" data-mp="2teqgqup84yjb">প্রবাহ ২:</b> লগইন → ক্যাপচার → প্রিভিউ → OCR → সংশোধন → যাচাইয়ের জন্য পাঠান → অবস্থা দেখুন
          </div>
        </aside>
      </div>
    </div>;
}